import { Signal1973xs1vkmdcb as Signal } from '../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  Companion_getInstance2eccs74uj90kl as Companion_getInstance,
  Edges2jf5wl855ambv as Edges,
} from './models/Rect.mjs';
import { set_safeInsets3hvkcq1e3pzpz as set_safeInsets } from './views/ViewContextExtensions.mjs';
import { AppState_getInstance1lcg5jamx8e1g as AppState_getInstance } from './reactive/AppState.js.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { get_dp28ag147e4p5cz as get_dp } from './models/data.commonHtml.mjs';
import { KeyCodes_instancevfnkc2xsbiba as KeyCodes_instance } from './models/KeyCode.commonHtml.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_debugMode2ku08uo1anfv as get_debugMode } from './debugger.mjs';
import { ViewWriter2xfqkrnuqv5cx as ViewWriter } from './views/ViewWriter.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { get_basePath37oh0bkfrtwru as get_basePath } from './navigation/Navigator.js.mjs';
import { RContext22p6sq97lnq6o as RContext } from './views/RContext.commonHtml.mjs';
import { ExternalServices_instancen7y3lfkh3gae as ExternalServices_instance } from './ExternalServices.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { SetAsBase1p1kkt5i4f45k as SetAsBase } from './models/Theme.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_0 } from './ViewWrapper.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function root(theme, app) {
  // Inline function 'kotlin.apply' call
  var this_0 = new (root$1())(theme);
  if (get_debugMode()) {
    var safe = Signal().fak(Companion_getInstance().zcz_1);
    set_safeInsets(this_0, safe);
    var times = {_v: 0};
    var tmp = AppState_getInstance();
    tmp.sdo((it) => {
      var tmp;
      if (it.pcy_1 && it.ocy_1 === KeyCodes_instance.eax(_Char___init__impl__6a9atx(101))) {
        println('Setting edges');
        var tmp_0;
        var _unary__edvuaz = times._v;
        times._v = _unary__edvuaz + 1 | 0;
        if ((_unary__edvuaz % 2 | 0) === 0) {
          tmp_0 = Edges().ad0(get_dp(100));
        } else {
          tmp_0 = Companion_getInstance().zcz_1;
        }
        safe.mam(tmp_0);
        tmp = true;
      } else {
        tmp = false;
      }
      return tmp;
    });
  }
  // Inline function 'kotlin.also' call
  app(this_0);
}
function RView$_get_themeChoice_$ref_gje4kp(p0) {
  return () => p0.ob6_1;
}
function RView$_set_themeChoice_$ref_6fnx25(p0) {
  return (_this__u8e3s4) => {
    p0.jba(_this__u8e3s4);
    return Unit_instance;
  };
}
var root$1Class;
function root$1() {
  if (root$1Class === VOID) {
    class $ extends ViewWriter() {
      constructor($theme) {
        super();
        this.vdo_1 = get_AppScope();
        var tmp = this;
        // Inline function 'kotlin.also' call
        var this_0 = new (RContext())(get_basePath());
        ExternalServices_instance.qcu_1 = this_0;
        tmp.wdo_1 = this_0;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
        var prev = this.bbb_1;
        var tmp_0 = this;
        tmp_0.bbb_1 = (_this__u8e3s4) => {
          var tmp0_safe_receiver = prev;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver(_this__u8e3s4);
          var tmp = KMutableProperty0();
          var tmp_0 = RView$_get_themeChoice_$ref_gje4kp(_this__u8e3s4);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('themeChoice', 0, tmp, tmp_0, RView$_set_themeChoice_$ref_6fnx25(_this__u8e3s4));
          reactiveScope(_this__u8e3s4, ($this$reactiveScope) => {
            var tmp$ret$2 = new (SetAsBase())($this$reactiveScope.baj($theme));
            this_0.set(tmp$ret$2);
            return Unit_instance;
          });
          return Unit_instance;
        };
        Companion_getInstance_0();
      }
      pc() {
        return this.wdo_1;
      }
      rba(view) {
        var tmp0_safe_receiver = document.body;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.append(view.tb5_1.xdo());
        }
      }
      ea2() {
        return this.vdo_1.ea2();
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [ViewWriter(), CoroutineScope()]);
    root$1Class = $;
  }
  return root$1Class;
}
//region block: exports
export {
  root as root92aurhljvuc2,
};
//endregion

//# sourceMappingURL=root.mjs.map
